import React, { useState, useEffect, useCallback } from 'react'
import { CircularProgress } from '@mui/material'
import { useSelector } from 'react-redux'

import { get } from 'services/api'

import classNames from 'classnames'
import { makeStyles } from '@mui/styles'
import Container, { LoadingContainer, styles } from './styles'
import ComplementaryReviewInfo from './ComplementaryReviewInfo'
import ReviewsList from './ReviewsList'

export default function ManualAnalysisList(props) {
  const { applicationId, checkType } = props
  const token = useSelector((state) => state.auth.access_token)
  const [reviewsList, setReviewsList] = useState([])
  const [review, setReview] = useState({
    background_check: null,
    reference_check: null,
  })
  const [loading, setLoading] = useState(false)

  const key = checkType === 'rfc' ? 'reference_check' : 'background_check'

  const load = useCallback(async () => {
    /** Seleciona um review para a partir dele exibir outras informações na tela.
     * 
     * Se houver mais de um review ligado a essa aplicação, não permite que o review usado 
     * seja um review de score board, pois ele é sempre exlcusivo a apenas uma aplicação e
     * a lista de 'Aplicações Envolvidas' ficaria incorreta.
     */
    const selectReview = (reviews) => {
      if (!reviews) {
        return {}
      }
      if (reviews.length === 1) {
        return reviews[0]
      }
      return reviews.find((r => r.review_type !== 'score_board')) ?? {}
    }

    setLoading(true)
    const res = await get({
      url: `/reviews/${checkType}?application_uuid=${applicationId}`,
      token: token,
    })
      .then((response) => response)
      .catch((error) => console.error(error))
    if (res) {
      setReviewsList(res.items)
      setReview(selectReview(res.items))
    }
    setLoading(false)
  }, [setReviewsList, applicationId, token, checkType])

  useEffect(() => {
    load()
  }, [load])
  
  const classes = makeStyles(() => (styles))()
  return (
    <Container>
      {loading ? (
        <LoadingContainer>
          <span>
            <CircularProgress size={70} />
          </span>
          <span>Buscando informações para revisão...</span>
        </LoadingContainer>
      ) : (
        <div className={classNames(classes.gappedItem, classes.largeGap)}>
          
          <ComplementaryReviewInfo review={review} check={review[key]}/>
          
          <ReviewsList reviews={reviewsList} splitReviewsByArea={true} reviewCheckType={checkType} />
        
        </div>
      )}
    </Container>
  )
}
